import React, { useMemo } from 'react';
import WidgetCard from '../Components/WidgetCard';
import useTranslation from '../../../util/hooks/useTranslation';
import useMonitor from '../util/useMonitor';
import { fetchMappedTagCount } from '../../../api/widget';
import SimpleCountWithoutCard from '../../MainPages/Components/SimpleCountWithoutCard';
import { useSelector } from 'react-redux';
import { checkFalsy } from '../../../util/common/util';

const defaultData = [];
const RegisteredAsset = ({ children, widgetInfo, ...restProps }) => {
    const t = useTranslation('RegisteredAsset');
    const { config } = widgetInfo;
    const { categoryList } = useSelector(state => state.CategoryInfo);
    const filterParam = useMemo(() => {
        let tempArr = [];
        categoryList
            .filter(category => category.parentCode === 'ASSET')
            .map(category => tempArr.push(category.categoryCode));
        let tempParam = {
            categoryCodes: tempArr.toString(),
        };
        return tempParam;
    }, [categoryList]);

    const { data } = useMonitor({
        config,
        defaultData,
        dynamicParam: filterParam,
        fetchData: fetchMappedTagCount,
    });

    return (
        <WidgetCard widgetInfo={widgetInfo} {...restProps}>
            <SimpleCountWithoutCard
                widgetInfo={{
                    title: t('Registered Asset'),
                    mainCnt: checkFalsy(data.registeredTargetCnt),
                    mainStatus: t('Registered'),
                    detailCnt: [
                        {
                            colorClass: 'color-secondary',
                            label: t('Mapped', 'Common'),
                            value: checkFalsy(data.mappedTargetCnt),
                        },
                        {
                            colorClass: 'color-danger',
                            label: t('Unmapped', 'Common'),
                            value: checkFalsy(data.unMappedTargetCnt),
                        },
                    ],
                }}
            />
            {children}
        </WidgetCard>
    );
};

export default RegisteredAsset;
